<template>
  <b-form
    class="w-full flex el-form-wrapper"
    @submit.prevent="submit"
  >
    <elements
      v-if="confirmation"
      v-model="section.options.content.orderForm.confirmation[0].content"
      :product="product"
      :classes="`--${section.sid}--form flex flex-col`"
      class="h-100"
      :config="section.options.content.orderForm"
      :form="form"
      drag-height="150px"
      :sub-el-props="{
        form: form,
        products: products
      }"
      @flow="handleFlow"
      @click.stop.native="$store.commit('editor/SET_PAGE', 'add-element')"
    />
    <elements
      v-else
      v-model="step.content"
      :product="product"
      :classes="`--${section.sid}--form flex flex-col`"
      class="h-100"
      :config="section.options.content.orderForm"
      :form="form"
      :form-style="section.style"
      :submit-section="submitSection"
      drag-height="150px"
      :gdpr="gdpr"
      :sub-el-props="{
        form: form,
        steps: section.options.content.orderForm.steps.length,
        products: products,
        'submit-section': submitSection,
        gdpr: gdpr
      }"
      @flow="handleFlow"
      @click.stop.native="$store.commit('editor/SET_PAGE', 'add-element')"
    />
  </b-form>
</template>

<script>
import SectionMixin from '@/components/mixins/SectionMixin'
import Elements from '@/components/builder/utils/Elements/Elements.vue'
import {mapActions, mapState} from 'vuex'
export default {
  name: 'OrderFormLayout',
  mixins: [SectionMixin],
  components: {
    Elements
  },
  props: {
    step: {
      type: Object,
      required: true
    },
    stepsCount: {
      type: Number,
      required: true
    },
    currentStep: {
      type: Number,
      required: true
    },
    confirmation: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      gdprCheck: false,
      loading: false
    }
  },
  computed: {
    ...mapState('orderForm', {
      forms: state => state.forms,
      selectedProduct: state => state.selectedProduct
    }),
    form () {
      return this.forms.find(item => item.id === this.section.uid)
    },
    products () {
      const form = this.selectedProduct?.find(item => item.id === this.section.uid)
      return form?.products || []
    },
    product () {
      return this.section.options.content.orderForm.product
    },
    gdpr () {
      if ((this.stepsCount - 1) === this.currentStep) {
        return this.selectedProduct[0]?.product?.gdpr || ''
      }
      return ''
    },
    submitSection () {
      return this.step.content.find(item => item.class === 'form-button')
    }
  },
  methods: {
    ...mapActions({
      setProvidersList: 'orderForm/setProvidersList'
    }),
    submit () {
      console.log('submit')
    }
  },
  watch: {
    selectedProduct (val) {
      if (val?.available_payments) {
        this.setProvidersList(val.available_payments.map((item) => {
          return {
            name: item.project_to_integration.integration.name,
            code: item.project_to_integration.integration.alpha_code
          }
        }))
      }
    }
  },
  mounted () {
    if (this.selectedProduct?.available_payments) {
      this.setProvidersList(this.selectedProduct.available_payments.map((item) => {
        return {
          name: item.project_to_integration.integration.name,
          code: item.project_to_integration.integration.alpha_code
        }
      }))
    }
  }
}
</script>